import api from '.';
import { buildParams } from '../helpers/tableUtil';
import { ChapterProps } from '../models/global';

class Survey {
  static async createSurvey(data) {
    const survey = await api.post('/survey', data);
    return survey.data;
  }

  static async getSurvey(id: string) {
    const survey = await api.get(`/survey/${id}`);
    return survey.data;
  }

  static async updateSurvey(id: string, data: ChapterProps[]) {
    const survey = await api.put(`/survey/${id}`, data);
    return survey.data;
  }

  static async getStaticValues() {
    const survey = await api.get('/survey/static-values');
    return survey.data;
  }

  static async createSurveySeries(data) {
    const survey = await api.post('/survey/survey-series', data);
    return survey.data;
  }

  static async updateSurveySeries({ id, name }: { id: string; name: string }) {
    const survey = await api.put(`/survey/survey-series/${id}`, { name });
    return survey.data;
  }

  static async getSurveySeries({ limit, page, orderData }) {
    const params = buildParams({ limit, page, orderData });
    const survey = await api.get(`/survey/survey-series${params}`);
    return survey.data;
  }

  static async getSurveySeriesById(id: string) {
    const survey = await api.get(`/survey/survey-series/${id}`);
    return survey.data;
  }

  static async cloneSurvey(id: string) {
    const survey = await api.post(`/survey/clone/${id}`);
    return survey.data;
  }

  static async closeSurvey(id: string) {
    const survey = await api.put(`/survey/close/${id}`);
    return survey.data;
  }

  static async publishSurvey({ id, sendEmail }: { id: string; sendEmail: boolean }) {
    const survey = await api.put(`/survey/publish/${id}`, { sendEmail });
    return survey.data;
  }

  static async reopenSurvey({ id, sendEmail }: { id: string; sendEmail: boolean }) {
    const survey = await api.put(`/survey/reopen/${id}`, { sendEmail });
    return survey.data;
  }

  static async saveNotes({ id, notes }) {
    const result = await api.put(`/survey/notes/${id}`, { notes });
    return result.data;
  }

  static async getCCEmail() {
    const result = await api.get('/survey/cc-email');
    return result.data;
  }

  static async updateCCEmail(email: string) {
    const result = await api.put('/survey/cc-email', { email });
    return result.data;
  }
}

export default Survey;
